/**
 * MessagePage component
 * @returns <ErrorPage />
 */
import Message from "../components/Message";

const MessagePage = ({ error, success }) => {
    // Define the error messages and their properties
    const errors = {
        404: {
            title: "No podemos encontrar la página que buscas",
            text: "Parece que estás buscando una página que fue eliminada o que nunca existió.",
            btnConfig: {
                tag: "button",
                text: "Volver al inicio",
                url: "/",
            },
        },

        500: {
            title: "Algo salió mal",
            text: "Tuvimos un problema. Te recomendamos esperar unos segundos y volver a intentarlo.",
            btnConfig: {
                tag: "button",
                text: "Reintentar",
                url: "/",
            },
        },

        paymentFailed: {
            title: "No pudimos realizar la compra",
            text: "Ocurrió un error en nuestros servicios, por favor espera unos minutos y volvé a intentarlo.",
            btnConfig: {
                tag: "button",
                text: "Reintentar",
                url: "/",
            },
        },

        paymentDeclined: {
            title: "Pago fue rechazado",
            text: "Detectamos un problema con tu tarjeta, te recomendamos realizar la compra utilizando otra de tus tarjetas.",
            btnConfig: {
                tag: "button",
                text: "Reintentar",
                url: "/",
            },
        },
    };

    // Define the success messages and their properties
    const successMessages = {
        purchase: {
            title: "Compraste con éxito",
            text: "¡Gracias por confiar en nosotros! Enviamos a tu correo un mensaje con toda la información de la compra.",
            btnConfig: {
                tag: "button",
                text: "Continuar explorando Lexus",
                url: "/",
            },
        },
    };
    return (
        <section className="message-page" style={{ paddingTop: 0 }}>
            {error && <Message message={errors[error]} />}

            {success && <Message message={successMessages[success]} />}
        </section>
    );
};

export default MessagePage;
